/**
 * OpenAI Configuration
 *
 * Models are prefixed with "openai/" to route through OpenAIProvider (mirrors
 * grok.ts / deepseek.ts's pattern). Chat models only — image models
 * (gpt-image-2, dall-e-3) are configured separately in
 * ChatSettingsPanel.tsx's IMAGE_MODEL_OPTIONS.
 */

export const OPENAI_MODELS = {
  // Current default — the "Fastest" tier's model app-wide.
  GPT_5_6_LUNA: 'openai/gpt-5.6-luna',
  // Current default — the "Everyday" tier's model app-wide.
  GPT_5_6_TERRA: 'openai/gpt-5.6-terra',
};

export const DEFAULT_OPENAI_MODEL = OPENAI_MODELS.GPT_5_6_LUNA;

export const AVAILABLE_OPENAI_MODELS = [
  {
    id: OPENAI_MODELS.GPT_5_6_LUNA,
    name: 'GPT-5.6 Luna',
    provider: 'openai',
    family: 'openai',
    description: 'Low-latency replies for quick, everyday questions (default Fastest tier)',
    capabilities: ['text', 'reasoning'],
    tier: 'fast',
  },
  {
    id: OPENAI_MODELS.GPT_5_6_TERRA,
    name: 'GPT-5.6 Terra',
    provider: 'openai',
    family: 'openai',
    description: 'Balanced everyday model for writing and analysis (default Everyday tier)',
    capabilities: ['text', 'reasoning', 'vision'],
    tier: 'balanced',
  },
];

/**
 * Check if a model ID is an OpenAI chat model (routed through OpenAIProvider).
 */
export function isOpenAIModel(modelId: string): boolean {
  return modelId.startsWith('openai/');
}

/**
 * Get OpenAI model name without prefix
 */
export function getOpenAIModelName(modelId: string): string {
  return modelId.replace('openai/', '');
}
